import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { FuelTypeActions } from 'redux/actions/settings/FuelTypeActions';
import { ModalActions } from "redux/actions/ModalActions";
import { UnitActions } from 'redux/actions/settings/UnitActions';

import { TableColumn, Table, TableRow } from 'app/components/common/Table';
import { StoreModel } from 'models/StoreModel';
import { LoginUser } from 'models/LoginUser';
import { FuelType } from 'models/FuelType';
import { Manufacturer } from 'models/Manufacturer';
import { Unit } from 'models/Unit';
import { PageContentHeader } from 'app/components/common/PageContentHeader';
import { Translations } from 'models/Translations';
import Translator from 'app/components/common/Translator';

interface Props {
    fetchFuelTypes: typeof FuelTypeActions.fetchFuelTypes;
    fetchUnits: typeof UnitActions.fetchUnits;
    addFuelTypeForm: typeof ModalActions.showModal;
    addFuelType: typeof FuelTypeActions.addFuelType;
    editFuelTypeForm: typeof ModalActions.showModal;
    editFuelType: typeof FuelTypeActions.editFuelType;
    deleteFuelType: typeof FuelTypeActions.deleteFuelType
    loginUser: LoginUser;
    fuelTypes: FuelType[];
    units: Unit[];
    manufacturers: Manufacturer[];
    translations: Translations;
}

class FuelTypes extends React.Component<Props> {
    componentDidMount() {
        if (this.loggedIn()) {
            if (!this.props.fuelTypes) {
                this.props.fetchFuelTypes(this.props.loginUser.token);
            }
            if (!this.props.units) {
                this.props.fetchUnits(this.props.loginUser.token);
            }
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.fuelTypes && this.props.units
    }

    setFuelTypeData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.fuelTypes.forEach(fuelType => {
                data.push({
                    dataObject: {
                        id: fuelType.id,
                        name: fuelType.name,
                        unit: fuelType.unit ?? Unit.empty(),
                        archivedDate: fuelType.archivedDate
                    }
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Fuel Type',
                accessor: 'name',
            },
            {
                header: 'Unit',
                accessor: 'unit',
            },
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Fuel Types" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="Fuel Types" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addFuelType}
                        addFormAction={this.props.addFuelTypeForm}
                        addFormData={{
                            header: "Add a new FuelType",
                            formObject: FuelType.empty(),
                        }}
                        editAction={this.props.editFuelType}
                        editFormAction={this.props.editFuelTypeForm}
                        editFormData={{
                            header: "Edit FuelType",
                        }}
                        deleteAction={this.props.deleteFuelType}
                        selectConfigs={[{ divId: 'unit', filter: (u: object) => Unit.hasUsage(u as Unit, 'Fuel') }]}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setFuelTypeData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        fuelTypes: state.fuelTypes,
        units: state.units,
        manufacturers: state.manufacturers,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchFuelTypes: bindActionCreators(FuelTypeActions.fetchFuelTypes, dispatch),
        fetchUnits: bindActionCreators(UnitActions.fetchUnits, dispatch),
        addFuelType: bindActionCreators(FuelTypeActions.addFuelType, dispatch),
        addFuelTypeForm: bindActionCreators(ModalActions.showModal, dispatch),
        editFuelType: bindActionCreators(FuelTypeActions.editFuelType, dispatch),
        editFuelTypeForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteFuelType: bindActionCreators(FuelTypeActions.deleteFuelType, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FuelTypes);